import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { legalLinks } from '../data/contact';
type ConsentCheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
  compact?: boolean; // one short line, for tight spaces like the hero request bar
};
export function ConsentCheckbox({
  id,
  checked,
  onChange,
  error = false,
  tone = 'light',
  className = '',
  compact = false
}: ConsentCheckboxProps) {
  const dark = tone === 'dark';
  const text = dark ? 'text-paper/75' : 'text-ink/70';
  const box = dark ? checked ? 'border-paper bg-paper text-ink' : 'border-paper/60' : checked ? 'border-ink bg-ink text-paper' : 'border-ink/50';
  return <div className={className} data-id="element-265" data-mp="8mezicx7zmna">
      <label htmlFor={id} className={`flex cursor-pointer items-start gap-3 text-[13px] font-light leading-[20px] ${text}`} data-id="element-266" data-mp="8m6qiw47x1hd">
        <span className="relative mt-[2px] inline-flex shrink-0" data-id="element-267" data-mp="3uwnwdm7qfg9w">
          <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-invalid={error} aria-describedby={error ? `${id}-error` : undefined} className="peer sr-only" data-id="element-268" data-mp="3uwxnxe8fdvhp" />
          <span className={`flex h-4 w-4 items-center justify-center border transition-colors duration-200 peer-focus-visible:outline peer-focus-visible:outline-1 peer-focus-visible:outline-offset-2 ${dark ? 'peer-focus-visible:outline-paper' : 'peer-focus-visible:outline-ink'} ${box}`} aria-hidden="true" data-id="element-269" data-mp="3p2xn1zs79cg">
            {checked && <CheckIcon className="h-3 w-3" strokeWidth={2.25} data-id="element-270" data-mp="mi6yp8fbwoh3" />}
          </span>
        </span>
        <span data-id="element-271" data-mp="10hezg5r544ne">
          {compact ? 'Under NDA, always. I agree my details are used per our ' : 'I agree that Superluxury may store and use my details to respond to this request, in confidence. Read how we handle your data in our '}
          <Link to={legalLinks.privacyPolicy} className={`underline underline-offset-2 transition-opacity duration-150 hover:opacity-70 ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-272" data-mp="3p7fkvbxhvk6z">
            data policy
          </Link>
          .
        </span>
      </label>
      {error && <p id={`${id}-error`} role="alert" className={`mt-1.5 pl-7 text-[13px] ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-273" data-mp="bum6h9ggwc9w">
          Please confirm before continuing.
        </p>}
    </div>;
}